export default "__VITE_ASSET__CN4f$pIf__"